export default (
  state = {
    payload: [],
  },
  action
) => {
  switch (action.type) {
    case "FETCH_DELETED_EMPLOYEES":
      return action.payload;
    case "DELETE_EMPLOYEE":
      return {
        ...state,
        payload: [action.payload.payload, ...state.payload],
      };
    case "RESTORE_EMPLOYEE":
      return {
        ...state,
        payload: state.payload.filter(
          (item) => item._id !== action.payload.payload._id
        ),
      };
    default:
      return state;
  }
};
